import { EntTerritorialsUnits } from "../handBooks/territorialsUnits";
import { EntTypeAnimal } from "../handBooks/typeAnimal";
import { EntBasicHB } from "../handBooks/basicHB";

export class EntAnimalRegister {
  id: number|null = null;
  year: number|null = null;
  region: EntTerritorialsUnits|null = null;
  area: EntTerritorialsUnits|null = null;
  territorialUnit: EntTerritorialsUnits|null = null;
  animalType: EntTypeAnimal|null = null;
  farmCategory: EntBasicHB|null = null;
  headAmount: number|null = null;
  dataSource: string|null = null;

  regionId?: number|null = null;
  areaId?: number|null = null;
  territorialUnitId?: number|null = null;
  animalTypeId?: number|null = null;
  farmCategoryId?: number|null = null;
}
